import { useMutation, useQueryClient } from "@tanstack/react-query";
import { rejectSignupRequest, SignupRequestDecisionResponse } from "../../../api/signupRequestsApi";
import { SignupRequest } from "../../../pages/Admin/UserRequests/signupRequestsMockData";
import { SIGNUP_REQUESTS_QUERY_KEY } from "./useSignupRequests";

const wasSuccessful = (response: SignupRequestDecisionResponse) => response?.status === "success";

export const useRejectSignupRequest = () => {
  const queryClient = useQueryClient();
  return useMutation(({ id, decisionNote }: { id: number; decisionNote?: string }) => rejectSignupRequest(id, decisionNote), {
    onSuccess: (result, { id }) => {
      if (!wasSuccessful(result)) return;
      queryClient.setQueryData<SignupRequest[]>(SIGNUP_REQUESTS_QUERY_KEY, (current) =>
        (current ?? []).filter((request) => request.id !== id)
      );
    },
  });
};
